import React, { useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";

function LeftNav() {
  const { role } = useAuth();
  const navigate = useNavigate();
  const [selectedApp, setSelectedApp] = useState("PingreeGrove"); // Default logo

  // Define logo based on selected app
  const getLogo = () => {
    switch (selectedApp) {
      case "PingreeGrove":
        return `${process.env.PUBLIC_URL}/logo.png`;
      default:
        return `${process.env.PUBLIC_URL}/logo.png`;
    }
  };

  const handleSelectApp = (appName) => {
    setSelectedApp(appName);
    if (role === "Admin") {
      if (appName === "PingreeGrove") {
        navigate("/admin/applications");
      } else if (appName === "Default") {
        navigate("/admin/dashboard");
      }
    }
  };

  const setApplicaton = () => {
    handleSelectApp("Default");
  };

  return (
    <aside className="sidebar text-center">
      {/* Dynamic Logo */}
      <img src={getLogo()} alt="Logo" className="admin-logo mb-3 mt-2" />

      <nav className="menu">
        {role === "Admin" && (
          <>
            {/* Default Links */}
            {(selectedApp === "PingreeGrove" || selectedApp === "Permits") && (
              <>
                <NavLink to="/admin/applications" className={({ isActive }) => (isActive ? "active" : "")}>
                  <img src={`${process.env.PUBLIC_URL}/Home.svg`} alt="" className="px-2" />
                  Applications
                </NavLink>
                <hr />
                {/* Billing and Invoicing is disabled as requested */}
                {/* 
                <NavLink to="/admin/invoices" className={({ isActive }) => (isActive ? "active" : "")}>
                  <img src={`${process.env.PUBLIC_URL}/Pie-Chart.svg`} alt="" className="px-2" />
                  Billing and Invoice
                </NavLink>
                <hr />
                */}
                <NavLink to="/admin/portal-settings" className={({ isActive }) => (isActive ? "active" : "")}>
                  <img src={`${process.env.PUBLIC_URL}/Pie-Chart.svg`} alt="" className="px-2" />
                  Portal Settings
                </NavLink>
                <hr />
                <NavLink to="/admin/users" className={({ isActive }) => (isActive ? "active" : "")}>
                  <img src={`${process.env.PUBLIC_URL}/Users.svg`} alt="" className="px-2" />
                  User Accounts
                </NavLink>
                <hr />
              </>
            )}

            {selectedApp === "Default" && (
              <>
               <div className="menu-item main-link" onClick={() => handleSelectApp("PingreeGrove")} style={{ cursor: "pointer" }}>
                <img src={`${process.env.PUBLIC_URL}/logo.png`} alt="" className="px-2" style={{ maxWidth: "50px" }} />
                Pingree Grove
              </div>
              </>
            )}
          </>
        )}
      </nav>

      {/* Back Button to Return to Default */}
      {selectedApp !== "Default" && (
        <button className="btn btn-outline-secondary mt-3" onClick={() => setApplicaton()}>
          Back to Main Panel
        </button>
      )}
    </aside>
  );
}

export default LeftNav;
